import { useMagicKeys as K, whenever as M, onClickOutside as R } from "@vueuse/core";
import { logicAnd as U } from "@vueuse/math";
import { defineComponent as G, ref as a, computed as t, toRef as J, watch as m, resolveComponent as h, openBlock as D, createBlock as Q, withCtx as v, createElementVNode as c, mergeProps as W, normalizeClass as l, renderSlot as k, createTextVNode as w, toDisplayString as T, createElementBlock as X, createVNode as I, createCommentVNode as P } from "vue";
import { usePopoverState as Y } from "@onereach/ui-components-common/hooks";
import { O as Z } from "./OrButton-C_hXddAf.mjs";
import { a as N } from "./OrButton.vue_vue_type_script_lang-W1ictbKz.mjs";
import { O as x } from "./OrInput-DBcNZlkx.mjs";
import { O as _ } from "./OrOverlay-BjrghiC-.mjs";
import { _ as oo } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var i = /* @__PURE__ */ ((o) => (o.D = "d", o.C = "c", o))(i || {});
const eo = [
  // Position
  "fixed md:static",
  "left-0",
  "right-0",
  "bottom-0",
  // Layout
  "layout-column",
  // Box
  "w-full md:w-[320px]",
  // Spacing
  "px-lg",
  "py-lg",
  "gap-md",
  // Shape
  "md:rounded-md",
  // Elevation
  "shadow-modal",
  "dark:shadow-modal-dark",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], to = [
  // Layout
  "layout-row justify-between",
  // Typography
  "typography-headline-3"
], no = [
  // Box
  "w-full",
  // Spacing
  "mt-md"
], ro = [
  // Spacing
  "gap-md"
], lo = {
  [i.C]: [
    // Layout
    "layout-row"
  ],
  [i.D]: [
    // Layout
    "layout-row-reverse"
  ]
}, ao = [
  // Layout
  "!grow",
  // Box
  "w-auto md:w-[128px]"
], io = G({
  name: "OrConfirm",
  components: {
    OrOverlay: _,
    OrButton: Z,
    OrInput: x
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    titleText: {
      type: String,
      required: !1,
      default: null
    },
    confirmButtonText: {
      type: String,
      default: "Confirm"
    },
    autoCloseOnConfirm: {
      type: Boolean,
      default: !0
    },
    cancelButtonText: {
      type: String,
      default: "Cancel"
    },
    confirmType: {
      type: String,
      default: () => i.C
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    confirmationText: {
      type: String,
      default: void 0
    },
    textConfirmationLabel: {
      type: String,
      default: void 0
    },
    textConfirmationPlaceholder: {
      type: String,
      default: void 0
    }
  },
  emits: [
    "update:state",
    "open",
    "close",
    "confirm"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close"
  ],
  setup(o, n) {
    const p = a(), y = a(), C = a(), V = t(() => [
      "or-confirm-v3",
      ...eo
    ]), g = t(() => [
      ...to
    ]), s = t(() => [
      ...no
    ]), B = t(() => [
      ...ro,
      ...lo[o.confirmType]
    ]), u = t(() => [
      ...ao
    ]), { state: $, open: A, close: f } = Y(J(o, "isOpen"), n.emit), d = a(!1), O = a("");
    m($, () => {
      O.value = "";
    });
    const { escape: F, enter: q } = K(), S = t(() => !!o.confirmationText && o.confirmationText !== O.value), E = t(() => !!o.disabled || S.value), L = t(
      () => o.confirmType === i.C ? N.Primary : N.Danger
    );
    function b() {
      !o.disabled && !S.value && n.emit("confirm");
    }
    function j() {
      d.value = !0;
    }
    function z() {
      d.value = !1;
    }
    function H() {
      b(), o.autoCloseOnConfirm && f();
    }
    return m(F, (e) => {
      e && f();
    }), m(y, (e) => {
      var r;
      return (r = e == null ? void 0 : e.focus) == null ? void 0 : r.call(e);
    }), m(C, (e) => {
      if (e && !o.confirmationText) {
        const r = e.root;
        r == null || r.focus();
      }
    }), M(U(q, d), () => b()), R(p, f), {
      root: p,
      confirmationInput: y,
      confirmationButton: C,
      confirmationValue: O,
      confirmButtonColor: L,
      isInvalid: S,
      isConfirmationButtonDisabled: E,
      state: $,
      isInputActive: d,
      escape: F,
      rootStyles: V,
      headerStyles: g,
      inputBoxStyles: s,
      footerStyles: B,
      buttonsStyles: u,
      confirm: b,
      onConfirmClick: H,
      open: A,
      close: f,
      onInputFocus: j,
      onInputBlur: z
    };
  }
}), so = {
  class: /* @__PURE__ */ l(["grow", "overflow-y-auto", "overflow-x-hidden"])
};
function uo(o, n, p, y, C, V) {
  const g = h("OrInput"), s = h("OrButton"), B = h("OrOverlay");
  return o.state === "open" ? (D(), Q(B, {
    key: 0,
    fullscreen: !0
  }, {
    default: v(() => [
      c("div", W(o.$attrs, {
        ref: "root",
        class: o.rootStyles,
        role: "alertdialog"
      }), [
        c("div", {
          class: l(o.headerStyles)
        }, [
          k(o.$slots, "header", {}, () => [
            w(T(o.titleText), 1)
          ])
        ], 2),
        c("div", so, [
          k(o.$slots, "default"),
          o.confirmationText ? (D(), X("div", {
            key: 0,
            class: l(o.inputBoxStyles)
          }, [
            I(g, {
              ref: "confirmationInput",
              modelValue: o.confirmationValue,
              "onUpdate:modelValue": n[0] || (n[0] = (u) => o.confirmationValue = u),
              label: o.textConfirmationLabel,
              placeholder: o.textConfirmationPlaceholder,
              onFocus: o.onInputFocus,
              onBlur: o.onInputBlur
            }, null, 8, ["modelValue", "label", "placeholder", "onFocus", "onBlur"])
          ], 2)) : P("", !0)
        ]),
        k(o.$slots, "footer", {
          confirm: o.confirm,
          cancel: o.close
        }, () => [
          c("div", {
            class: l(o.footerStyles)
          }, [
            I(s, {
              class: l(o.buttonsStyles),
              variant: "outlined",
              disabled: o.loading,
              onClick: n[1] || (n[1] = (u) => o.close())
            }, {
              default: v(() => [
                w(T(o.cancelButtonText), 1)
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            I(s, {
              ref: "confirmationButton",
              class: l(o.buttonsStyles),
              color: o.confirmButtonColor,
              loading: o.loading,
              disabled: o.isConfirmationButtonDisabled,
              onClick: o.onConfirmClick
            }, {
              default: v(() => [
                w(T(o.confirmButtonText), 1)
              ]),
              _: 1
            }, 8, ["class", "color", "loading", "disabled", "onClick"])
          ], 2)
        ])
      ], 16)
    ]),
    _: 3
  })) : P("", !0);
}
const So = /* @__PURE__ */ oo(io, [["render", uo]]);
export {
  i as C,
  So as O
};
//# sourceMappingURL=OrConfirm-o50DtKQg.mjs.map
